exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tanpawrap[data-v-3476c9cb]{white-space:nowrap}", ""]);

// exports
